/**
 * Coach matching-details server functions (expertise, audience, approach).
 *
 * Aliases: coach details, discovery details, expertise options
 */

import { createServerFn } from "@tanstack/react-start";

import { requireCoachAuth } from "~/lib/coach-middleware";
import { CoachDetailsSchema } from "~/lib/shared/schemas/coach-details";

export const getCoachDetailsData = createServerFn({ method: "GET" })
  .middleware([requireCoachAuth])
  .handler(async ({ context }) => {
    const { getCoachMatchingDetails } =
      await import("~/lib/server/coach-matching-details");

    return getCoachMatchingDetails(context.coach);
  });

export const getExpertiseOptions = createServerFn({ method: "GET" })
  .middleware([requireCoachAuth])
  .handler(async () => {
    const { getExpertiseSubcategories } =
      await import("~/lib/server/expertise");

    return getExpertiseSubcategories();
  });

export const saveCoachDetails = createServerFn({ method: "POST" })
  .middleware([requireCoachAuth])
  .validator((data: unknown) => CoachDetailsSchema.parse(data))
  .handler(async ({ data, context }) => {
    const { saveCoachMatchingDetails } =
      await import("~/lib/server/coach-matching-details");

    return saveCoachMatchingDetails(context.coach, data);
  });
